<template>
    <div class="w-full">
        <Dropdown class="w-full" v-model="selectedCountry" :options="countriesOptions" optionLabel="countryName" filter placeholder="/">
            <template #value="slotProps">
                <div v-if="slotProps.value" class="h-full flex align-items-center gap-3" style="color: var(--theme-font-color)">
                    <FlagIcon v-if="slotProps.value.code.length>0" :countryCode="slotProps.value.code.toLowerCase()" :size="dropdownSize"/>
                    <span :class="`country-label-${dropdownSize}`" style="color: var(--theme-font-color)">{{ slotProps.value.countryName }}</span>
                </div>
                <span v-else class="h-full flex align-items-center" :class="`country-label-${dropdownSize}`" style="color: var(--theme-font-color); opacity: 0.65">
                    {{ slotProps.placeholder }}
                </span>
            </template>
            <template #option="slotProps">
                <div class="flex align-items-center gap-3">
                    <FlagIcon v-if="slotProps.option.code.length>0" :countryCode="slotProps.option.code.toLowerCase()" :size="dropdownSize"/>
                    <span :class="`country-label-${dropdownSize}`">{{ slotProps.option.countryName }}</span>
                </div>
            </template>
        </Dropdown>
    </div>
</template>

<script setup>
// --- IMPORTS ---
import { ref, toRefs, watchEffect } from 'vue'
// PrimeVue
import Dropdown from 'primevue/dropdown';
// Others
import FlagIcon from "@/components/Modules/FlagIcon.vue";
import CountriesUtils from '@/composables/CountriesUtils'

const { countries } = CountriesUtils()

// --- PROPS ---
const props = defineProps({
    dropdownSize: String,
    initialSelectedCountryCode: String,
    selectedCountryCode: String
})
const { initialSelectedCountryCode, selectedCountryCode } = toRefs(props)

// --- EMITS ---
const emit = defineEmits(['selectCountry'])

// --- VARIABLES ---
const countriesOptions = ref([{'countryName': '---', 'code': ''}, ...countries])
const selectedCountry = ref(countriesOptions.value.filter((country) => country.code === initialSelectedCountryCode.value)[0])

watchEffect(() => {
    if (selectedCountry.value && selectedCountry.value.code.length===0) {selectedCountry.value = null}
    emit('selectCountry', selectedCountry.value ? selectedCountry.value.code : '')
})
watchEffect(() => { // Make sure it matches between parent and child
    selectedCountry.value = countriesOptions.value.filter((country) => country.code === selectedCountryCode.value)[0]
})
</script>

<style scoped>
.country-label {
    font-weight: var(--inputcomponent-font-weight);
}
.country-label-small {
    font-size: var(--inputcomponent-normal-font-size);
}
.country-label-big {
    font-size: var(--inputcomponent-big-font-size);
}
.country-icon-small {
    width: 1.33rem;
    height: 1rem;
}
.country-icon-big {
    width: 1.6rem;
    height: 1.2rem;
}
:deep(.p-dropdown .p-dropdown-trigger) {
    color: var(--theme-font-color);
    opacity: 0.65;
}
</style>